import { ReceivedSamples, ReceivedSamplesSeries } from './received-samples.types';
import { SequencedSamplesSeries, SequencedSamples } from './sequenced-samples.types';

export * from './awaiting-samples.types';
export * from './demographics.types';
export * from './received-samples.types';
export * from './overview.types';
export * from './participant-recruitment.types';
export * from './sample-tracking.types';
export * from './sequenced-samples.types';
export * from './samples-view-graph.types';
export * from './campaigns.types';
export * from './samples.types';
export * from './kit-failure-reason.types';

export enum TabId {
  COLLECTION = 'collection-and-sequencing',
  RECRUITMENT = 'participant-recruitment',
  RESULTS = 'delivery-and-results',
  SAMPLES = 'sample-tracking',
}

export interface FormattedSampleSeries {
  total: number;
  type: {
    [key: string]: {
      percentage: number;
      total: number;
    };
  };
}

export interface FormattedSampleSeriesOptions {
  includeType: boolean;
  includeStatus: boolean;
}

export type SequencingSamplesSerie = SequencedSamplesSeries | ReceivedSamplesSeries;

export type SequencingSamples = ReceivedSamples | SequencedSamples;

export interface Collection {
  percentage: number;
  total: number;
  totalRecollect?: number;
  totalValid?: number;
}

interface BloodType extends Collection {
  BLOOD: Collection;
}
interface SalivaType extends Collection {
  SALIVA: Collection;
}
interface BuccalType extends Collection {
  BUCCAL_SWAB: Collection;
}

export interface CollectionType extends Collection {
  IN_PERSON: BloodType & SalivaType & BuccalType;
  AT_HOME: SalivaType & BuccalType;
  REUSE: BloodType & SalivaType & BuccalType;
  NOT_AVAILABLE: BloodType & SalivaType & BuccalType;
}

export interface SampleData {
  collectionLocation: string;
  status?: string;
  type?: string;
  groupValue?: string;
  value: number;
}
